export default __webpack_public_path__ + "static/media/fullstack-project-3.b9331ce4.png";